import { useStore } from '@/hooks/useStore';
import { useLocation, useNavigate } from 'react-router-dom';
import { observer } from 'mobx-react-lite';
import { useEffect, useState } from 'react';
import { Button } from '@/components/common/Button';
import { t } from 'i18next';
import { useTranslation } from 'react-i18next';
import { ITEMS_CONST, ROUTES } from '@/configs/constants';
import { toastify } from '@/utils/toastify';
import Header from '@/components/layout/Header';
import { ItemStatus, ParamsRequestListDropItem, ParamsRequestListRegistered } from '@/types/item';
import MenuBar from '@/components/common/MenuBar';
import { ItemMenuBar } from '@/types/menu';
import { SwipeList } from '@/components/swipe-list';
import trashIcon from '@/assets/images/pngs/Trash.png';
import { flowResult } from 'mobx';
import imgPlus from '@/assets/images/pngs/Plus.png';
import ModalReact from '@/components/common/ModalReact';
import contentDialod from './ContentModal';
import { getParamsLoadMore } from '@/utils/utils';

export default observer(function CollectedItems() {
    // store
    const {
        itemsStore: { getListColected, listItemsColected, getListItemRegistered, listItemRegisted, deleteRegisteredItem, total },
        modalStore: { showAlertModal, hideModal },
        apiStore: { isLoading }
    } = useStore();
    const { t } = useTranslation();
    const navigate = useNavigate();
    const goBack = () => {
        navigate(ROUTES.home.href);
    };
    const defaultParamsRegister: ParamsRequestListRegistered = {
        page: 1,
        size: 10,
        status: '',
        activity: ''
    };
    const defaultParamsDrop: ParamsRequestListDropItem = {
        page: 1,
        size: 10,
        type: -1
    };
    const [paramsRegistered, setParamRegistered] = useState<ParamsRequestListRegistered>(defaultParamsRegister);
    const [paramsDrop, setParamDrop] = useState<ParamsRequestListDropItem>(defaultParamsDrop);
    const [showModal, setShowModal] = useState<boolean>(false);

    const [menus, setMenus] = useState<ItemMenuBar[]>([{
        id: 1,
        label: t('text.dropItems'),
        isSelected: true
    },
    {
        id: 2,
        label: t('text.addItems'),
        isSelected: false
    }]);

    useEffect(() => {
        if (menus[0].isSelected) {
            getListColected(paramsDrop);
        } else {
            getListItemRegistered(paramsRegistered);
        }
    }, [menus]);

    const submitFilter = () => {
        setShowModal(false);
        const statusFilter = listStatusFilter.find(e => e.isSelected === true)?.id || 0;
        const activityFilter = listActivityFilter.find(e => e.isSelected === true)?.id || 0;
        setParamRegistered({ ...paramsRegistered, status: statusFilter === -1 ? '' : statusFilter, activity: activityFilter === -1 ? '' : activityFilter });
        getListItemRegistered({ ...paramsRegistered, status: statusFilter === -1 ? '' : statusFilter, activity: activityFilter === -1 ? '' : activityFilter });
    };

    const handleFilterDropItem = () => {
        setShowModal(false);
        const couponSelected = listFilterItemType.find(e => e.id === ITEMS_CONST.ITEM_TYPE.COUPON)?.isSelected || false;
        const otherSelected = listFilterItemType.find(e => e.id === ITEMS_CONST.ITEM_TYPE.NOT_SET)?.isSelected || false;
        let newParam: ParamsRequestListDropItem = { ...paramsDrop };
        if (couponSelected && otherSelected) {
            newParam.type = -1;
        } else if (couponSelected) {
            newParam.type = ITEMS_CONST.ITEM_TYPE.COUPON;
        } else if (otherSelected) {
            newParam.type = ITEMS_CONST.ITEM_TYPE.NOT_SET;
        } else {
            newParam.type = 2;
        }
        setParamDrop(newParam);
        getListColected(newParam);
    };

    const [listActivityFilter, setListActivityFilter] = useState<ItemStatus[]>([

        { id: -1, title: t('itemStatus.all'), isSelected: true },
        { id: ITEMS_CONST.ACTIVITY.PUBLISHED__ON_MAP, title: t('itemActivity.onMap'), isSelected: false },
        { id: ITEMS_CONST.ACTIVITY.PUBLISHED__GET_IT, title: t('itemActivity.getIt'), isSelected: false },
        { id: ITEMS_CONST.ACTIVITY.PUBLISHED__USED, title: t('itemActivity.used'), isSelected: false },
        { id: ITEMS_CONST.ACTIVITY.PUBLISHED__RESTORE, title: t('itemActivity.restore'), isSelected: false },
        { id: ITEMS_CONST.ACTIVITY.PRIVATE__REPORT, title: t('itemActivity.report'), isSelected: false },
        { id: ITEMS_CONST.ACTIVITY.PRIVATE__WITHDRAWAL, title: t('itemActivity.withdrawal'), isSelected: false },
        { id: ITEMS_CONST.ACTIVITY.PRIVATE__EXPIRED, title: t('itemActivity.expired'), isSelected: false }
    ]);
    const [listStatusFilter, setListStatusFilter] = useState<ItemStatus[]>([
        { id: -1, title: t('itemStatus.all'), isSelected: true },
        { id: ITEMS_CONST.STATUS.PUBLISHED, title: t('itemStatus.published'), isSelected: false },
        { id: ITEMS_CONST.STATUS.UN_PUBLISHED, title: t('itemStatus.unPublict'), isSelected: false },
        { id: ITEMS_CONST.STATUS.PRIVATE, title: t('itemStatus.private'), isSelected: false }
    ]);

    const [listFilterItemType, setListFilterItemType] = useState<ItemStatus[]>([
        { id: ITEMS_CONST.ITEM_TYPE.COUPON, title: t('text.coupon'), isSelected: true },
        { id: ITEMS_CONST.ITEM_TYPE.NOT_SET, title: t('text.other'), isSelected: true }
    ]);

    const handleRightAction = async (id: string) => {
        const activity = listItemRegisted.find(e => e.id === parseInt(id))?.activity;
        if (activity === ITEMS_CONST.ACTIVITY.PUBLISHED__GET_IT || activity === ITEMS_CONST.ACTIVITY.PUBLISHED__USED) {
            toastify('error', t('messages.cannotDeleteThisItem'));
            return;
        }
        const res = await flowResult(deleteRegisteredItem(id));
        if (res) {
            toastify('success', t('messages.deleteSuccess'));
            getListItemRegistered(paramsRegistered);
        }
    };

    const handleClickItem = (id, title) => {
        if (menus[0].isSelected) {
            navigate(ROUTES.detailItemCollected.href, { state: { itemId: id } });
        } else {
            navigate(ROUTES.editRegisteredItem.href, { state: { itemId: id } });
        }
    };
    const handleRegisteredNewItem = () => {
        navigate(ROUTES.registerNewItem.href);
    };

    const onLoadMore = async () => {
        if (menus[0].isSelected) {
            const newParams = getParamsLoadMore(paramsDrop, total);
            if (!newParams) return;
            setParamDrop({ ...paramsDrop, ...newParams });
            return await flowResult(getListColected({ ...paramsDrop, size: newParams.size }));
        } else {
            const newParams = getParamsLoadMore(paramsRegistered, total);
            if (!newParams) return;
            setParamRegistered({ ...paramsRegistered, ...newParams });
            return await flowResult(getListItemRegistered({ ...paramsRegistered, size: newParams.size }));
        }
    };

    return (
        <div className='w-screen h-screen flex flex-col justify-start pt-[72px]'>
            <Header title={t('text.ownedItems')} goBackFunction={goBack} />
            <div className='mx-4'>
                <MenuBar
                    onChangeMenu={id => setMenus(prev => prev.map(e =>
                        e.id === id ? { ...e, isSelected: true } : { ...e, isSelected: false }))}
                    menus={menus}
                    containerClassname='h-10 rounded-1 my-6'
                    itemSelectedClassname='bg-white text-textAccountType'
                    itemClassname='text-textAccountName'
                />

                <SwipeList
                    rightFunction={id => handleRightAction(id)}
                    listClassname='h-[calc(100vh-72px-72px-28px-40px)] w-full'
                    blockSwipe={menus[0].isSelected}
                    iconRight={trashIcon}
                    items={menus[0].isSelected ? listItemsColected : listItemRegisted}
                    onClickItem={(id, title) => handleClickItem(id, title)}
                    showStatusItem={menus[1].isSelected}
                    filterShowFunc={() => setShowModal(true)}
                    onEndReached={async () => {
                        onLoadMore();
                    }}
                    isLoading={isLoading}
                />
                {menus[1].isSelected && (
                    <button onClick={handleRegisteredNewItem} className='w-[50px] h-[50px] bg-greenMain absolute bottom-6 right-4 rounded-full flex justify-center items-center'>
                        <img alt={imgPlus} src={imgPlus} className='w-8 h-8' />
                    </button>
                )}
                <ModalReact
                    isOpen={showModal}
                    content={
                        menus[0].isSelected ?
                            contentDialod.DialogFilterDropItem({
                                setShowModal,
                                listFilter: listFilterItemType,
                                onSubmit: () => handleFilterDropItem(),
                                onSelect: (id) => {
                                    setListFilterItemType(prevItems => prevItems.map(item =>
                                        item.id === id ?
                                            { ...item, isSelected: !item.isSelected } :
                                            { ...item }));
                                }
                            }) :
                            contentDialod.DialogFilterStatus({
                                setShowModal,
                                listActivityFilter,
                                onSubmit: () => submitFilter(),
                                listStatusFilter,
                                onSelect: (type, id) => {
                                    switch (type) {
                                        case 1:
                                            setListStatusFilter(prevItems =>
                                                prevItems.map(item =>
                                                    item.id === id ?
                                                        { ...item, isSelected: true } :
                                                        { ...item, isSelected: false }));
                                            break;
                                        case 2:
                                            setListActivityFilter(prevItems =>
                                                prevItems.map(item =>
                                                    item.id === id ?
                                                        { ...item, isSelected: true } :
                                                        { ...item, isSelected: false }));
                                            break;
                                        default:
                                            break;
                                    }
                                }
                            })
                    }
                />
            </div>

        </div>
    );
});
